module.exports = __webpack_public_path__ + "static/media/extract_demo.445b430a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/extract_demo.png
// module id = 97
// module chunks = 0